/**
 * Theme Requirements Aggregation for Z Modular
 * 
 * Extends the base aster theme requirements with Z Modular specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-aster/requirements';

/**
 * Z Modular component requirement overrides.
 * Add requirements for any override components here.
 */
const zmodularOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Z Modular theme.
 * Inherits from aster theme and overrides with Z Modular components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...zmodularOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
